import { useEffect, useRef } from 'react';

import HeartLoader from '@/shared/ui/HeartLoader';

import { useCopilot } from '../../CopilotContext';
import { Message } from '../Message/Message';

import styles from './ChatPanel.module.css';

export function ChatPanel() {
  const { messages, isLoadingMessages, status } = useCopilot();
  const scrollRef = useRef<HTMLDivElement | null>(null);
  // Surface a dropped/rejected socket instead of leaving the chat silently
  // stuck (e.g. the doctor's account can't be verified by the copilot).
  const disconnected = status === 'error' || status === 'closed';

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    // Only auto-scroll if the user is already near the bottom or just sent a
    // message — otherwise streaming tokens would yank them away while reading.
    const isNearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 100;
    const lastIsUser = messages[messages.length - 1]?.role === 'user';
    if (isNearBottom || lastIsUser) {
      el.scrollTop = el.scrollHeight;
    }
  }, [messages]);

  if (isLoadingMessages && messages.length === 0) {
    return (
      <div className={styles.messagesLoading}>
        <HeartLoader size="sm" />
      </div>
    );
  }

  return (
    <div ref={scrollRef} className={styles.messages}>
      {disconnected && (
        <div className={styles.connectionNotice} role="status">
          <span className={styles.spinner} aria-hidden />
          <span>Reconnecting…</span>
        </div>
      )}
      {messages.map((m) => (
        <Message key={m.id} message={m} />
      ))}
    </div>
  );
}
